import { MediaDocumentModel } from '@modules/media/models/media-document.model';
import { MediaImageModel } from '@modules/media/models/media-image.model';

import { TestCarSpec } from '../interfaces/test-car-spec.interface';
import { TestCarInterface } from '../interfaces/test-car.interface';

export class TestCarModel {
  public id?: string;
  public title: string;
  public specs: TestCarSpec[] = [];
  public subSpecs: TestCarSpec[] = [];
  public cardSpecs: TestCarSpec[] = [];
  public fuelLabel: string;
  public image?: MediaImageModel;
  public document?: MediaDocumentModel;
  public filter: {
    label: string;
    value: string;
  };

  constructor(data: TestCarInterface) {
    this.id = data.id;
    this.title = data.title;
    this.fuelLabel = data.fuelLabel;
    this.document = data.document ? new MediaDocumentModel(data.document) : undefined;
    this.image = data.image ? new MediaImageModel(data.image) : undefined;
    this.filter = {
      label: data.filter,
      value: data.filter,
    };
    this.specs = data.specs;
    this.subSpecs = data.subSpecs;
    this.cardSpecs = data.cardSpecs;
  }
}
